export default class ToggleShowMore {
  constructor(element) {
    this.element = element;
    this.contentElement = this.element.querySelector('.content');
    this.toggleButton = this.element.querySelector('a.toggle');

    this.expandedClass = 'is-expanded';

    this.addEvents();
  }

  addEvents() {
    this.toggleButton.addEventListener('click', _ => {
      this.element.classList.toggle(this.expandedClass);
    });
  }
}